import { createFileRoute } from "@tanstack/react-router";
import { ContractsPage } from "@/app/connect/pages/contracts";

type ContractsSearchParams = {
	provider_id?: string;
};

function cleanId(value: unknown): string | undefined {
	if (typeof value === "number") return String(value);
	if (typeof value === "string") {
		const cleaned = value.replace(/^["']|["']$/g, "");
		return cleaned || undefined;
	}
	return undefined;
}

export const Route = createFileRoute("/connect/contracts")({
	validateSearch: (search: Record<string, unknown>): ContractsSearchParams => ({
		provider_id: cleanId(search.provider_id),
	}),
	component: ContractsPage,
});
